(function () {
  'use strict';

  window.SetHover = function () {
    var sfEls = document.getElementById('nav').getElementsByTagName('LI');
    for (var i = 0; i < sfEls.length; i++) {
      sfEls[i].onmouseover = function () {
        this.className += ' sfhover';
      };
      sfEls[i].onmouseout = function () {
        this.className = this.className.replace(new RegExp('( )?sfhover\\b'), '');
      };
    }

    if (document.getElementById('float')) {
      sfEls = document.getElementById('float').getElementsByTagName('LI');
      for (var i = 0; i < sfEls.length; i++) {
        sfEls[i].onmouseover = function () {
          this.className += ' sfhover';
        };
        sfEls[i].onmouseout = function () {
          this.className = this.className.replace(new RegExp('( )?sfhover\\b'), '');
        };
      }
    }
  };

  window.submitSearch = function () {
    var searchField = document.getElementById('searchField');
    var searchFieldValue = searchField && searchField.value;

    if (searchFieldValue) {
      window.location.href = 'FreeTextSearch.php?NewSearch=true&SearchOnlyCurrentWorkflow=false&SearchText=' + encodeURIComponent(searchFieldValue);
    } else {
      alert('Please enter a search term');
    }
  };

  document.addEventListener('DOMContentLoaded', initializeSearchField);

  function initializeSearchField () {
    var masthead = document.getElementById('masthead');
    if (!masthead) {
      return;
    }

    // Some of this code appears dead. At least, it doesn't apply to the /app route, so blocking it in a check for
    // jQuery, which is only available in the legacy environment.
    if (window.jQuery) {
      var $ = window.jQuery;
      $('.button_sm').button();
    };

    // These elements don't show up on all pages, so check before trying to use 'em.
    var dropdownBox = document.getElementById('dropdown_box');
    if (dropdownBox) {
      dropdownBox.addEventListener(('mouseleave'), function () {
        dropdownBox.style.display = 'none';
      });
    }

    var searchField = document.getElementById('searchField');
    if (searchField) {
      searchField.placeholder = 'Search';
    }
  }
}());
